module.exports = __webpack_public_path__ + "static/media/gentleness.b1cbf8a0.jpg";